import TagEditForm, {
  TagFormData,
} from "components/foundation/Tag/TagEditForm";
import useTagsAutoCompleteQuery from "features/tag/hooks/queries/useTagsAutoCompleteQuery";
import TagPageListItem from "pages/tag/TagPageListItem";
import React, { SetStateAction, useContext, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { DirtyContext } from "..";

interface DocClassEditFormItemProps {
  onDuplicate: () => void;
  documentClasses?: string[];
  setDocClasses: React.Dispatch<React.SetStateAction<string[]>>;
}

const DocClassEditFormItem = ({
  onDuplicate,
  documentClasses,
  setDocClasses,
}: DocClassEditFormItemProps) => {
  const methods = useForm<TagFormData>({
    defaultValues: {
      tag: "",
    },
  });

  /* 태그 */
  const { data: autoCompleteData } = useTagsAutoCompleteQuery({
    searchTerm: methods.watch("tag"),
  });

  const context = useContext(DirtyContext);

  useEffect(() => {
    if (methods.formState.isDirty) {
      context?.markDirty();
    }
  }, [context, methods.formState.isDirty]);

  return (
    <FormProvider {...methods}>
      <TagPageListItem title="문서구분태그">
        <TagEditForm
          tags={documentClasses || []}
          setTags={(callback: SetStateAction<string[]>) => {
            let result: string[];
            if (typeof callback === "function") {
              result = callback(documentClasses || []);
            } else {
              result = callback;
            }
            setDocClasses(result);
          }}
          autocomplete={autoCompleteData?.data.result.map((i) => ({
            label: i,
            value: i,
          }))}
          placeholder="태그를 추가하세요"
          onDuplicate={onDuplicate}
        />
      </TagPageListItem>
    </FormProvider>
  );
};

export default DocClassEditFormItem;
